export default __webpack_public_path__ + "static/media/celuba-frente-1.91233eca.jpg";